import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './SellLanding.scss';

//import ConfidenceCenter from '../../ConfidenceCenter/ConfidenceCenter';
import { moduleActions } from '../../../redux/modules';
import { getBalanceAsOfDate } from '../../../redux/modules/funds/UserFunds/userFunds.selectors';
import {
  getDateOfBirth,
  getIsAddressAvailable,
  getIsNotForeignAddress,
  getUserBusinessPartyId,
  didPersonalInformationFail,
} from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { BALANCES_AS_OF_MODAL } from '../../../redux/modules/modals/modals.module';
import {
  getIsMobileParam,
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { isSalesforceRep } from '../../../redux/modules/authentication/authentication.module.selectors';
import SellSteps from '../SellSteps/SellSteps';
import { isAppSell } from 'src/utils/transactions-util';

import {
  ADDRESS_INCOMPLETE,
  APP_FAILURE,
  COLLEGE_SELL_REDIRECT,
  DOB_FAILURE,
  executingAppSellMessages,
  executingSellMessages,
  FOREIGN_ADDRESS,
  loadingBuySellAppMessages,
  TIMEOUT,
  NOT_RETAIL_CLIENT,
  ZERO_BALANCE_FUND,
} from '../../../settings/settings';
import { getIsZeroDollarBalanceFund } from '../../../redux/modules/sellTransaction/sellTransaction.selectors';
import ExcessiveTradingPolicyNote from '../../Shared/ExcessiveTradingPolicyNote/ExcessiveTradingPolicyNote';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import { getProductTypes } from '../../../redux/modules/productTypes/productType.selectors';
import iconHelp from '../../../assets/images/icon_help.svg';
import If from '../../Shared/If/If';
import { AppSellSteps } from 'src/components/AppSell/AppSellSteps';
import { isSell } from '../../../utils/transactions-util';
import { getApplicationStatus } from '../../../redux/modules/applicationData/applicationData.selectors';
//import CollegeBrandingContainer from '../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
export const SellLanding = ({
  actions: { openModal },
  isIFrame,
  customerWebViewEnabled,
  isSalesforceRep,
  applicationData,
  balanceAsOfDate,
  dateOfBirth,
  personalInfoFailed,
  executeRedemption: {
    redemption: { redemptionResultFailed, redemptionResultLoading },
  },
  isAddressAvailable,
  isNotForeignAddress,
  isCorporateAccountType,
  isZeroDollarBalanceFund,
  personalInformation: { data: personalData },
  submitRedemption,
  hasRasFundsOnly,
  hasAppFundsOnly,
  productTypes,
}) => {
  const hasMutualFund =
    productTypes &&
    (productTypes.hasMutualFund || (isAppSell() && productTypes.hasAPP));
  const isLoaderVisible = applicationData.isLoading || redemptionResultLoading;
  const { retailEnabled } = personalData;
  const message = applicationData.isLoading
    ? loadingBuySellAppMessages
    : redemptionResultLoading
    ? isAppSell()
      ? executingAppSellMessages
      : executingSellMessages
    : '';
  const getError = () => {
    if (!personalInfoFailed && !dateOfBirth && !isCorporateAccountType) {
      return {
        type: DOB_FAILURE,
        hasError: true,
      };
    }
    if (!personalInfoFailed && !isNotForeignAddress) {
      return {
        type: FOREIGN_ADDRESS,
        hasError: true,
      };
    }
    if (applicationData.hasFailed) {
      return {
        type: APP_FAILURE,
        hasError: true,
      };
    }
    if (!retailEnabled && !isSalesforceRep) {
      return {
        type: NOT_RETAIL_CLIENT,
        hasError: true,
      };
    }
    if (redemptionResultFailed) {
      return {
        type: TIMEOUT,
        hasError: true,
      };
    }
    if (!isAddressAvailable) {
      return {
        type: ADDRESS_INCOMPLETE,
        hasError: true,
      };
    }
    if (isZeroDollarBalanceFund) {
      return {
        type: ZERO_BALANCE_FUND,
        hasError: true,
      };
    }
    if (!hasMutualFund && isSell()) {
      return {
        type: COLLEGE_SELL_REDIRECT,
        hasError: true,
      };
    }
    if (
      !hasMutualFund &&
      !((hasRasFundsOnly || hasAppFundsOnly) && isAppSell())
    ) {
      return {
        type: COLLEGE_SELL_REDIRECT,
        hasError: true,
      };
    }
    return {
      type: '',
      hasError: false,
    };
  };
  return (
    <div id="sell-page-container">
      <FullPageLoader
        isVisible={isLoaderVisible}
        errorType={getError().type}
        hasError={getError().hasError}
        messages={message}
      />
      <If test={!(isIFrame || (!customerWebViewEnabled && isSalesforceRep))}>
        <StepsPageBackground />
      </If>
      <div className="container">
        {isAppSell() ? (
          <AppSellSteps
            submitRedemption={submitRedemption}
            hasRasFundsOnly={hasRasFundsOnly}
            hasAppFundsOnly={hasAppFundsOnly}
          />
        ) : (
          <SellSteps submitRedemption={submitRedemption} />
        )}
        <button
          className="sell-landing-balance-tooltip"
          onClick={() => openModal(BALANCES_AS_OF_MODAL)}
        >
          * Balances as of {balanceAsOfDate}
          <img
            id="balance-tooltip-icon"
            alt="help"
            className="sell-landing-balance-tooltip-icon"
            src={iconHelp}
          />
        </button>
        <hr />
        <ExcessiveTradingPolicyNote />
        <p style={{ margin: '10px 0' }}>2639550</p>
      </div>
    </div>
  );
};
/*
  commented out the help bar at the bottom of sell for now
 <If test={userBusinessPartyId}>
 <ConfidenceCenter businessPartyId={userBusinessPartyId} />
 </If>
 */
const mapStateToProps = (state) => {
  const {
    executeRedemption,
    progress: { currentStep },
  } = state;
  return {
    isIFrame: isEmbeddedInIFrame(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    isSalesforceRep: isSalesforceRep(state),
    applicationData: getApplicationStatus(state),
    balanceAsOfDate: getBalanceAsOfDate(state),
    currentStep,
    dateOfBirth: getDateOfBirth(state),
    personalInfoFailed: didPersonalInformationFail(state),
    executeRedemption,
    isAddressAvailable: getIsAddressAvailable(state),
    isNotForeignAddress: getIsNotForeignAddress(state),
    isZeroDollarBalanceFund: getIsZeroDollarBalanceFund(state),
    userBusinessPartyId: getUserBusinessPartyId(state),
    productTypes: getProductTypes(state),
    isMobileParam: getIsMobileParam(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      openModal: moduleActions.openModal,
      openChat: moduleActions.openChat,
    },
    dispatch
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SellLanding
);
